import { RouterProvider } from "react-aria-components";
import { Outlet, useHref, useNavigate } from "react-router";
import { AuthInitializer } from "@/src/auth/components/auth-initializer";
import { ErrorBoundary } from "@/src/common/components/error-boundary";

export function RootLayout() {
	const navigate = useNavigate();
	return (
		<ErrorBoundary>
			<RouterProvider navigate={navigate} useHref={useHref}>
				<AuthInitializer>
					<Outlet />
				</AuthInitializer>
			</RouterProvider>
		</ErrorBoundary>
	);
}
